export default "__VITE_ASSET__CT7lC0pV__"